import React from 'react'
import PropTypes from 'prop-types'
import { Route } from "react-router-dom"
import PrivateRoute from '../../utils/PrivateRoute'
import Register from './Register'
import Activate from './Activate'
import Login from './Login'
import Logout from './Logout'
import Account from './Account'
import AccountEdit from './AccountEdit'
import ForgetPwd from './ForgetPwd'
import ResetPwd from './ResetPwd'
import AuthService from '../../utils/auth.service'

import './user.css'

class User extends React.Component {
    render() {
        const isLogin = AuthService.isLogin()

        return (
            <React.Fragment>
                <Route path="/user/register">
                    <Register />
                </Route>
                <Route path="/user/activate/:uidb64/:token">
                    <Activate />
                </Route>
                <Route path="/user/login">
                    <Login setUserState={this.props.setUserState} setPathSnippetsState={this.props.setPathSnippetsState} />
                </Route>
                <Route path="/user/logout">
                    <Logout />
                </Route>
                <PrivateRoute 
                    exact 
                    path="/user/account/edit"
                    isAuthenticated={isLogin}
                    component={AccountEdit}
                    redirect="/user/login"
                    setPathSnippetsState={this.props.setPathSnippetsState}
                />
                <PrivateRoute 
                    path="/user/account"
                    isAuthenticated={isLogin}
                    component={Account}
                    redirect="/user/login"
                    setPathSnippetsState={this.props.setPathSnippetsState}
                    exact
                />
                <Route path="/user/forgetpwd">
                    <ForgetPwd />
                </Route>
                <Route path="/user/resetpwd/:uidb64/:token">
                    <ResetPwd />
                </Route>
            </React.Fragment>
        )
    }
}

User.propTypes = {
    setUserState: PropTypes.func,
    setPathSnippetsState: PropTypes.func
}

export default User